import { WALLET_RATES } from "@/pages/retailer/wallet/constants";
import type { AdminWalletRow } from "@/types/wallet";

export function initials(name: string): string {
  return name
    .split(" ")
    .map((p) => p[0])
    .filter(Boolean)
    .slice(0, 2)
    .join("")
    .toUpperCase();
}

export type BalanceTier = "healthy" | "low" | "blocked";

export function balanceTier(available: number): BalanceTier {
  if (available < WALLET_RATES.MIN_BALANCE) return "blocked";
  if (available < WALLET_RATES.LOW_BALANCE_THRESHOLD) return "low";
  return "healthy";
}

export const BALANCE_STATUS_META: Record<BalanceTier, { label: string; text: string; bg: string }> = {
  healthy: { label: "Healthy", text: "text-emerald-700", bg: "bg-success-bg" },
  low: { label: "Low Balance", text: "text-amber-700", bg: "bg-warning-bg" },
  blocked: { label: "Blocked", text: "text-red-700", bg: "bg-danger-bg" },
};

export function availableColor(available: number): string {
  if (available < WALLET_RATES.MIN_BALANCE) return "text-danger";
  if (available < WALLET_RATES.LOW_BALANCE_THRESHOLD) return "text-amber-600";
  return "text-ink";
}

export const BALANCE_FILTERS = [
  { value: "", label: "All Balances" },
  { value: "healthy", label: "Healthy" },
  { value: "low", label: "Low" },
  { value: "blocked", label: "Blocked" },
];


export const TOPUP_STATUS_FILTERS = [
  { value: "", label: "All Status" },
  { value: "PENDING", label: "Pending" },
  { value: "APPROVED", label: "Approved" },
  { value: "REJECTED", label: "Rejected" },
];

export function walletAvailable(w: { totalBalance?: number; balance?: number }): number {
  return w.totalBalance ?? w.balance ?? 0;
}

/** Map the API's wallet status to the badge tiers used by this screen. */
export function tierFromStatus(status: AdminWalletRow["status"]): BalanceTier {
  if (status === "BLOCKED") return "blocked";
  if (status === "LOW") return "low";
  return "healthy";
}

let txnSeq = 0;
let walletSeq = 0;

export function nextTxnId(): string {
  txnSeq += 1;
  const d = new Date();
  const ymd = `${d.getFullYear()}${String(d.getMonth() + 1).padStart(2, "0")}${String(d.getDate()).padStart(2, "0")}`;
  return `TXN${ymd}${String(txnSeq).padStart(2, "0")}`;
}

export function nextWalletId(): string {
  walletSeq += 1;
  return `w-${Date.now()}-${walletSeq}`;
}